import { AnalyticsResourceType, Roles } from "@doitintl/cmp-models";

import { useAuthContext } from "../../../Context/AuthContext";
import { type HasCollaborators, useCanEditSelectedObjectsPermissions } from "../utilities";

export function useSelectionOperations<T extends { data: HasCollaborators & { type?: string } }>(selected: T[]) {
  const currentUser = useAuthContext({ mustHaveUser: true }).currentUser;

  const selectedWithoutPresets = selected.filter((item) => item.data.type !== AnalyticsResourceType.PRESET);

  const canEdit = useCanEditSelectedObjectsPermissions(
    currentUser.email,
    selectedWithoutPresets.map((x) => x.data)
  );

  const isOwnerOfAllSelected = selectedWithoutPresets.every((item) =>
    item.data.collaborators.some((collab) => collab.email === currentUser.email && collab.role === Roles.OWNER)
  );

  if (selected.length === 0) {
    return {
      canEdit: false,
      canDelete: false,
      presetSelected: false,
      selectedWithoutPresets: [],
    };
  }

  const presetSelected = selected.length !== selectedWithoutPresets.length;

  return {
    canEdit,
    canDelete: isOwnerOfAllSelected && !presetSelected,
    presetSelected,
    selectedWithoutPresets,
  };
}
